/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Check_Case_4Inputs */

const en_how_we_work_check_case_4 = /** @type {(inputs: How_We_Work_Check_Case_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unavailable integration`)
};

const lv_how_we_work_check_case_4 = /** @type {(inputs: How_We_Work_Check_Case_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepieejama integrācija`)
};

/**
* | output |
* | --- |
* | "An unavailable integration" |
*
* @param {How_We_Work_Check_Case_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_check_case_4 = /** @type {((inputs?: How_We_Work_Check_Case_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Check_Case_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_check_case_4(inputs)
	return en_how_we_work_check_case_4(inputs)
});